import React from 'react'
import { Link } from 'react-router-dom'
import FavouriteTool from './FavouriteTool'
import ProductSlider from './ProductSlider'

function Shop() {
  return (
    <div>
      <div className="breadcrumb-row">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="d-flex justify-content-between align-items-center breadcrumb-item">
                <div className="breadcrumb-title-heading">
                  <h1 className="title">Shop</h1>
                </div>
                <div className="breadcrumb-wrapper">
                  <span className="mr-1">
                    <i className="ti ti-home"></i>
                  </span>
                  <Link title="Homepage" to="/">
                    Home
                  </Link>
                  <span className="ttm-bread-sep">&nbsp;/&nbsp;</span>
                  <span className="ttm-textcolor-skincolor">Shop</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Section Start -->
    <!-- Fruits Start --> */}
      <FavouriteTool />
      {/* <!-- Fruits End -->
        <!-- Fruits Start --> */}
      <ProductSlider />
    </div>
  );
}

export default Shop